import useModal, { MODAL_XL } from "../../../hooks/useModal";
import { Modal } from "../../../Modal";
import ChatAIWS from "../../../../../ia/ChatAIWS";

import { env } from "../../../../../../env";
import { useState } from "react";
import { Wrapper } from "../../../Wrapper/Wrapper";


export const ChatButtonAI = () => {

    const useIA = env.USE_IA ?? false;

    //new
    const [open, setOpen] = useState(false);
    //old    
    const modal = useModal("Chat ERP", MODAL_XL);


    if (!useIA) return null;

    return (
        <>
            <button
                title="Abrir chat ERP"
                type="button"
                onClick={() => setOpen(prev => !prev)}
                className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none"
            >
                <i className="ri-terminal-line fs-22"></i>
            </button>

            <Wrapper open={open} onClose={() => setOpen(false)}>
                <ChatAIWS />
            </Wrapper>

            {/* <button title="Ingresa al chat ERP" type="button" onClick={() => modal.open()} className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                <i className="ri-terminal-line fs-22"></i>
            </button>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <ChatAIWS />
            </Modal> */}
        </>
    )
}